export const Location = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            LOCALIZAÇÃO
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Venha nos visitar em Antônio Prado/RS. Estamos aqui para acolher e
            ajudar.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-white text-brand-blue">
        <div className="max-w-7xl mx-auto px-4">
          {/* Map Section */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-3xl shadow-xl">
            <h2 className="text-4xl font-bold font-montserrat mb-8 text-center bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
              Nossa Localização
            </h2>
            <p className="text-xl font-roboto text-gray-700 mb-12 leading-relaxed text-center max-w-4xl mx-auto">
              Estamos localizados em Antônio Prado/RS, prontos para acolher e
              oferecer o suporte necessário para sua recuperação.
            </p>

            <div className="h-96 md:h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl mb-8">
              <iframe
                className="w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3493.535023427181!2d-51.293358299999994!3d-28.882445299999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951e80e2de31b533%3A0x37e4452376263e4!2sEstr.%20Par%C3%A1%20Nossa%20Sra.%20da%20Sa%C3%BAde%2C%20502%20-%20Ant%C3%B4nio%20Prado%2C%20RS%2C%2095250-000!5e0!3m2!1spt-BR!2sbr!4v1769776346799!5m2!1spt-BR!2sbr"
                title="Mapa da localização da Comunidade Terapêutica PATRE Cristo Rei"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <a
                href="https://www.google.com/maps/place/Estr.+Par%C3%A1+Nossa+Sra.+da+Sa%C3%BAde,+502+-+Ant%C3%B4nio+Prado,+RS,+95250-000/@-28.882445,-51.293358,17z"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-blue text-white font-bold font-montserrat py-4 px-8 rounded-full text-lg uppercase tracking-wider shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
                Abrir no Google Maps
              </a>
              <a
                href="https://waze.com/ul?ll=-28.882445,-51.293358&navigate=yes"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#00B7F3] text-white font-bold font-montserrat py-4 px-8 rounded-full text-lg uppercase tracking-wider shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11c0 .3-.1.6-.2.9l-2.1 5.5c-.3.8-1.1 1.3-2 1.3h-11.4c-.9 0-1.7-.5-2-1.3L2.2 11.9c-.1-.3-.2-.6-.2-.9 0-3.3 2.7-6 6-6h8c3.3 0 6 2.7 6 6z" />
                  <path d="M8 8.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zm8 0c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z" />
                  <path d="M12 13l-3 3h6l-3-3z" />
                </svg>
                Abrir no Waze
              </a>
            </div>

            <div className="text-center space-y-6">
              <p className="text-xl font-roboto text-gray-700">
                <strong>Endereço:</strong> Estr. Nossa Sra. da Saúde, 502 -
                Antônio Prado, RS, 95250-000
              </p>
              <p className="text-xl font-roboto text-gray-700">
                <strong>Telefone:</strong>{" "}
                <a
                  href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-blue hover:text-brand-yellow transition-colors duration-300 font-semibold text-2xl"
                >
                  (54) 99699-8885
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Venha nos Visitar
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            Nossa porta está sempre aberta para quem precisa de ajuda. Agende
            uma visita ou entre em contato conosco.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
            >
              Agendar Visita
            </a>
            <a
              href="#tratamento"
              onClick={() => scrollToSection("tratamento")}
              className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Tratamento
            </a>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
